import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class CreateGroup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customerList: [],
      roles: [],
      customerID: "default",
      name: "",
      description: "",
      color: "#160f9e",
      icon: "fa fa-truck",
      status: "1",
      customerID_error: false,
      name_error: false,
    };
    this.formSubmit = false;
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({ customerID: values.customerId });
    }
    this.props.setLoadingPageAction(true);

    //Get all customer id
    try {
      const customerList = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ customerList: customerList.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }

  handleColorChange = (e) => {
    this.setState({ color: e.target.value });
  }

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleConfirmIconChange(e) {
    this.setState({ icon: e.target.value });
  }

  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        await axios.post(
          `${apiHost}/api/Group/GroupRegister`,
          {
            Name: this.state.name,
            CustomerId: this.state.customerID,
            Description: this.state.description,
            Colour: this.state.color,
            Icon: this.state.icon,
            Status: this.state.status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.props.history.goBack();
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          // this.props.setErrorMessageAction(`${e}`);
          if (e.response.data.statusCode == "8") {
            this.props.setErrorMessageAction("Group Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  render() {
    const values = queryString.parse(this.props.location.search);
    var selectCustomerTag;
    if (values.selectedAsset) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
          value={this.state.customerID}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    }
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create Group </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Create Group</h2>
              <h6>Create a new Group</h6>
              <hr></hr>
              <Form>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> CustomerID</span>
                  </Form.Label>
                  <Col sm={10}>
                    {selectCustomerTag}
                    <p
                      style={
                        this.state.customerID_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Name</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleNameChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Description</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      onChange={this.handleDescriptionChange.bind(this)}
                      rows="3"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Colour</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.color}
                      onChange={this.handleColorChange.bind(this)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Icon</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.icon}
                      onChange={this.handleConfirmIconChange.bind(this)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Status</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="select"
                      onChange={this.handleStatusChange.bind(this)}
                    >
                      <option value="1">Active</option>
                      <option value="0">Disabled</option>
                    </Form.Control>
                  </Col>
                </Form.Group>
                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      // this.props.history.push("/groups");
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateGroup);
